import { EventEmitterService } from 'js/services/eventEmitter.service';

export const publicEventsAPIService = new EventEmitterService();
